module.exports = __webpack_public_path__ + "static/media/sa-cavalcante.aa6ee177.png";